import {
  getAuthentication,
  getStationDashboard,
  getStationInfo,
} from '@/api/channel/station';
import {useQuery} from '@tanstack/react-query';
import {STATION_QUERY_KEY} from './queryKeys';
import {AxiosError} from 'axios';
import {
  StationAuthenticationModel,
  StationDashboardModel,
  StationModel,
} from '@/types/channel/station/station.model';
import {
  mapStationAuthenticationSchemaToModel,
  mapStationDashboardSchemaToModel,
  mapStationSchemaToModel,
} from '@/types/channel/station/station.mapper';
import {StationError} from '@/types/channel/station/station.schema';
import {isLogin} from '@/utils/main';

export const useAuthenticationQuery = () => {
  return useQuery<StationAuthenticationModel, AxiosError<StationError>>({
    queryKey: STATION_QUERY_KEY.AUTHENTICATION,
    queryFn: () =>
      getAuthentication().then(mapStationAuthenticationSchemaToModel),
    enabled: isLogin(),
  });
};

export const useStationInfoQuery = (userId: string) => {
  return useQuery<StationModel, AxiosError<StationError>>({
    queryKey: STATION_QUERY_KEY.STATION_INFO(userId),
    queryFn: async () => {
      const stationDetail = await getStationInfo(userId);
      return mapStationSchemaToModel(stationDetail);
    },
  });
};

export const useStationDashboardQuery = (userId: string) => {
  return useQuery<StationDashboardModel, AxiosError<StationError>>({
    queryKey: STATION_QUERY_KEY.STATION_DASHBOARD(userId),
    queryFn: () =>
      getStationDashboard(userId).then(mapStationDashboardSchemaToModel),
  });
};
